<template>
<a-card>
  <a-form :form="form">
    <a-row>
      <a-col :span="24">
        <a-form-item class="remark" label="评价人" v-bind="formItemLayout">
          <a-input disabled v-model="loadData.userName"
          />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <a-form-item class="remark" label="年度" v-bind="formItemLayout">
        <a-select  v-decorator="[
                                    'year',
                                    {initialValue:loadData.year,rules: [{ required: true, message: '请选择年度' }]}
                                ]" @popupScroll="onYearChange" @change="handlePanelChange1">
          <a-select-option v-for="(item,index) in yearData" :value="item" :key="index">
            {{item}}年
          </a-select-option>
        </a-select>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <a-form-item class="remark" label="被评专家" v-bind="formItemLayout">
          <a-select
              show-search
              placeholder="被评专家"
              option-filter-prop="children"
              :filter-option="filterOption"
              v-decorator="[
                                    'expertId',
                                    {initialValue:loadData.expertId,rules: [{ required: true, message: '请选择整治企业' }]}
                                ]"
          >
            <a-select-option v-for="(item,index) in experts" :key="index" :value="item.id">{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <a-form-item class="remark" label="评价等级" v-bind="formItemLayout">
          <dict-cascader dict-key="expertYearAssess.level" v-decorator="[
                                    'level',
                                    {initialValue:loadData.level,rules: [{ required: true, message: '请选择评价等级' }]}
                                ]"/>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <a-form-item class="remark" label="评分" v-bind="formItemLayout">
          <a-input-number :maxLength="3" v-decorator="[
                                    'score',
                                    {initialValue:loadData.score,rules: [{ required: true, message: '请填写评分' }]}
                                ]" placeholder='评分'
                       />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <a-form-item class="remark" label="评价内容" v-bind="formItemLayout">
          <a-textarea :rows="4" :maxLength="500" v-decorator="[
                                    'content',
                                    {initialValue:loadData.content,rules: [{ required: true, message: '请填写评价内容' }]}
                                ]" placeholder='评价内容'
          />
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</a-card>
</template>

<script>
import moment from 'moment'
import qs from 'qs'
import DictCascader from '@/components/dict/DictCascader'
const uuidv4 = require('uuid/v4')
export default {
  name: 'ExpertYearAssessForm',
  components: {
    DictCascader
  },
  data () {
    return {
      user: this.$ls.get('user'),
      form: this.$form.createForm(this),
      caseTypeId: this.$route.query.caseTypeId,
      formItemLayout: {
        labelCol: {
          md: { span: 5 }
        },
        wrapperCol: {
          md: { span: 15 }
        }
      },
      formItemLayoutMealType: {
        labelCol: {
          md: { span: 3 }
        },
        wrapperCol: {
          md: { span: 18 }
        }
      },
      otherTypeShow: false,
      trip: {
        procId: '',
        id: this.$route.query.id ? this.$route.query.id : uuidv4()
      },
      loadData: {
      },
      fmks: [],
      yearData: [],
      experts: []
    }
  },
  created () {
    this.getYearData()
    this.loadData = {
      addTime: moment(new Date(), 'YYYY-MM-DD'),
      userName: this.user.name
    }
    if (this.$route.query.id) {
      this.getById(this.$route.query.id)
    }
    this.$http.get('/api/1/expertmain/expertInfo/query_idName.json').then((res) => {
      this.experts = res.result
    })
  },
  methods: {
    disabledDate (current) {
      return current && current < moment().subtract(1, 'days').endOf('day')
    },
    getById (id) {
      this.$http.get('/api/1/notice/get_ImNoticeById.json?id=' + id).then((res) => {
        this.loadData = res.result
        this.loadData.userName = res.result.extras.userName
        // this.form.setFieldsValue(this.loadData)
      })
    },
    submit () {
      const that = this
      that.form.validateFields((err, values) => {
        if (err) {
          return
        }
        values.id = that.trip.id
        if (this.$route.query.id) {
          values.id = that.loadData.id
        }
        const api = this.$route.query.id
          ? '/api/1/expertyearassess/update_ExpertYearAssess.json'
          : '/api/1/expertyearassess/add_ExpertYearAssess.json'
        let msgType = this.$route.query.id ? '编辑' : '添加'


        console.log(values)
        that.$http.post(api, qs.parse(this.formatArrayOrObjectOffNull(values))).then((res) => {
          if (res.code !== 200) {
            return
          }
          that.$message.success(`${msgType}成功`)
          that.$router.push({
            path: `/expertYearAssess/view?id=${that.trip.id}`
          })
        })
      })
    },
    mealTypeChange (item) {
      console.log(item)
      var filter = item.filter(e => e === '6')
      if (filter.length !== 0) {
        this.otherTypeShow = true
      } else {
        this.otherTypeShow = false
      }
    },
    onChangeProcess (id) {
      this.trip.procId = id
    },
    formatArrayOrObjectOffNull (data) {
      var y
      for (var x in data) {
        y = data[x]
        if (y instanceof Object) y = this.formatArrayOrObjectOffNull(y)
        if (y === 'null' || y === null || y === '' || typeof y === 'undefined' || (y instanceof Object && Object.keys(y).length === 0)) {
          delete data[x]
        }
      }
      return data
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    getYearData () {
      let dateNow = new Date()
      let month = dateNow.getMonth() + 1
      let year = dateNow.getFullYear()
      let arr = []
      arr.push(year)
      for (let i = 0, j = 1; i < 10; i++, j++) {
        arr.push(year - j)
        // arr.push(year + j)
      }
      // for (let i = 0, j = 1; i < 5; i++, j++) {
      //   arr.push(year + j)
      // }
      arr.sort((val1, val2) => val2 - val1)
      this.yearData = arr
    },
    handlePanelChange1 (value, mode) {
      console.log(value)
      // this.statisYear.time = value
    },
    onYearChange (e) {
      const { target } = e
      if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
        var year = Math.min.apply(null, this.yearData)
        for (let i = 0, j = 1; i < 10; i++, j++) {
          this.yearData.push(year - j)
        }
        this.yearData.sort((val1, val2) => val2 - val1)
      } else if (target.scrollTop === 0) {
        var year1 = Math.max.apply(null, this.yearData)
        for (let i = 0, j = 1; i < 5; i++, j++) {
          this.yearData.push(year1 + j)
        }
        this.yearData.sort((val1, val2) => val2 - val1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-col-md-3 {
  width: 15%;
}
.mealform-number {
  width: 14% !important;
  border-top: 0px;
  border-right: 0px;
  border-left: 0px;
}
.hotelName {
  /deep/ .ant-col-md-4{
    width: 18.66% !important;
  }
}
.remark {
  /deep/ .ant-col-md-3{
    width: 10.4% !important;
  }
  /deep/ .ant-col-md-18{
    width: 81.3% !important;
  }
}

</style>
